import React from 'react'
import { Grid, Box, useMediaQuery } from "@mui/material";

function Header() {
    const isMobile = useMediaQuery("(max-width:600px)");

    return (
        <React.Fragment>
            <Grid item xs={7.2} sm={6.5} order={{ sm: 2, md: 1 }}>
                <Box
                    sx={{
                        p: { xs: 1, md: 2, xl: 2 },
                        display: "flex",
                        justifyContent: "center",
                        maxWidth: { xs: "60px", md: "60px", lg: "80px" },
                    }}
                >
                    <a href="/">
                        <img
                            src={"../../assets/images/TrueSelfy-logo.svg"}
                            alt="true-selfy"
                            loading="lazy"
                            style={{
                                maxWidth: `${isMobile ? "80px" : "80px"}`,
                                width: "100%",
                            }}
                        />
                    </a>
                </Box>
            </Grid>
        </React.Fragment>
    )
}

export default Header